<template>
  <AuthPage>
    <ResetPasswordForm />
  </AuthPage>
</template>

<script>
import ResetPasswordForm from "@/components/ResetPasswordForm.vue";

export default {
  name: "ResetPassword",
  components: {
    ResetPasswordForm,
  },
};
</script>
